/**
 * 2007-2018 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2018 PrestaShop SA
 * @license   https://opensource.org/licenses/AFL-3.0 Academic Free License 3.0 (AFL-3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import 'expose-loader?Tether!tether';
import 'bootstrap-touchspin';

// import fontawesome from "@fortawesome/fontawesome";
// import farCalendar from "@fortawesome/fontawesome-pro-regular/faCalendarAlt";
// import farEnvelope from "@fortawesome/fontawesome-pro-regular/faEnvelope";
// import fasArrowUp from "@fortawesome/fontawesome-pro-solid/faArrowUp";
//
// fontawesome.library.add(farCalendar, farEnvelope, fasArrowUp);
// FONT AWESOME ICONS

import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';
import './display';

import DropDown from './components/drop-down';
import Form from './components/form';
import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';
import TopMenu from './components/top-menu';
import PageLazyLoad from './components/Lazyload';
import debounce from './components/debounce';
import OffCanvas from './components/offcanvas';
import PageLoader from './components/page-loader';
import Headroom from 'headroom.js';
import VatNumberValidation from './components/VatNumberValidation';

import './components/debounce';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.scrollbox.min';

import './components/block-cart';
import FetchThenExecute from './utils/fetchThenExecute';

prestashop.pageLoader = new PageLoader();

prestashop.pageLazyLoad = new PageLazyLoad({
  selector: '.lazyload',
});

// import 'lazysizes';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let topMenuEl = $('.js-top-menu ul[data-depth="0"]');
  let dropDown = new DropDown(dropDownEl);
  let topMenu = new TopMenu(topMenuEl);
  let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  const offCanvas = new OffCanvas();
  const vatValidation = new VatNumberValidation();
  dropDown.init();
  form.init();
  topMenu.init();
  productMinitature.init();
  productSelect.init();
  initTooltip();
  handlePushOnCart();
  fetchSliders();
  offCanvas.offCanvasInit('.cart-offcanvas-button', '#offcanvas-cart', '#offcanvas-cart-close');
  offCanvas.offCanvasInit('.offcanvas-myaccount-btn', '#offcanvas-login', '#offcanvas-login__close');
  offCanvas.offCanvasInit('.offcanvas-blog-menu-btn', '#offcanvas-blog-menu', '#offcanvas-menu__close');
  vatValidation.init();

  $('.blog-category-menu__item').each(function() {
    const $menuItem = $(this);
    const $submenu = $menuItem.find(".blog-category-menu__submenu");
    const $mobileToggle = $menuItem.find(".blog-category-menu__item--arrow");

    if ($(window).width() > 768) {
      $menuItem.on("mouseover", function() {
        $submenu.addClass('show');
      });
  
      $menuItem.on('mouseout', function() {
        $submenu.removeClass('show');
      });
    }else {
      $mobileToggle.on("click", function() {
        $submenu.toggleClass('show');
      });
    }
    
  })
  if ($(window).width() > 768) {
    $('.blog-category-menu__item--arrow').on('click', function(e) {
      e.preventDefault();
    })
  }

  $('body').tooltip({
    selector: '.cart-summary-tooltip--tooltip-toggler',
    container: 'body',
    template: '<div class="tooltip cart-summary-tooltip--tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>'
  });
  
  const fixedHeader = document.querySelector('#header');
  if (fixedHeader) {
    var options = {
      offset: 50,
    };
  };
  if (fixedHeader) {
    const headroom = new Headroom(fixedHeader, options);
    if ($(window).width() < 768) {
      headroom.init();
    }
  }
  
  
  
  prestashop.on('updatedCart', () => {
    prestashop.pageLazyLoad.update();
  });
  prestashop.on('displayTypeFn', () => {
    prestashop.pageLazyLoad.update();
  });
  $(document).on('click', '.cart-offcanvas-button', () => {
    prestashop.pageLazyLoad.update();
  });
  prestashop.on('updateProductList', () => {
    prestashop.pageLazyLoad.update();
    prestashop.pageLoader.hideLoader();
  });
  prestashop.on('updateFacets', () => {
    prestashop.pageLoader.showLoader();
  });
  prestashop.on('updatedProduct', () => {
    prestashop.pageLazyLoad.update();
    productImagesSelect();
  });
  
  if ($(window).width() < 767) {
    $('#cms iframe').parent().fitVids();
  }

  $(document).on('as4-After-Init-Search-Results', function(e, idSearch, searchMethod, stepSearch) {
    prestashop.pageLoader.hideLoader();
  });
  $(document).on('as4-Criterion-Change', function(e, idSearch, idCriterionGroup, idCriterion, criterionName, groupType) {
    prestashop.pageLoader.showLoader();
  });
  $(document).on('as4-Search-Reset', function(e, idSearch) {
    console.log('as4-Search-Reset')
  });


  let iframeCode = $('#iframeHolder').data('iframe');
  let dataYtTitleFetched = $('.productImage__buttons').data('yt-title-fetched');

  $(document).on('click', '.productImage__button--movie', function() {
    if(dataYtTitleFetched === 0) {
      $('.productImage__buttons').data( 'yt-title-fetched', 1 );
      dataYtTitleFetched = $('.productImage__buttons').data('yt-title-fetched');
      $.get(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${iframeCode}&format=json`, function(data) {
        let productPageYtModalTitle = data.title;
        $('.product-page-yt-modal .modal_title').append(productPageYtModalTitle);
      });
    }
  });
  $(document).on('click', '.product-page-yt-open-btn', function(){
    if(!$('.product-page-yt-iframe').length) {
      $('.product-page-yt-modal img, .product-page-yt-open-btn').hide();
      $('#iframeHolder').html(`<iframe class="product-page-yt-iframe" width="100%" height="100vh" allow="autoplay" id="iframe" src="https://www.youtube.com/embed/${iframeCode}?autoplay=1&version=3&enablejsapi=1"></iframe>`);
      $('.product-page-yt-iframe').parent().fitVids();
    }
  });
  
  $('.product-page-yt-modal').on('hidden.bs.modal', function(e) {
    $('.product-page-yt-iframe', this).each(function() {
      $('.fluid-width-video-wrapper').remove();
      $('.product-page-yt-modal img , .product-page-yt-open-btn').show();
      $(this).remove();
    });
  });

  

  prestashop.on('updatedCart', function (e) {
    if (e.eventType !== 'undefined' && e.eventType == 'updateCart' && typeof e.resp.cart_footer !== 'undefined') {
        setTimeout(function() {
            $('#hookDisplayShoppingCartFooter').replaceWith('<div id="hookDisplayShoppingCartFooter">' + e.resp.cart_footer + '</div>');
            handlePushOnCart();
        }, 100);
    }
  });

  $(document).on('click', '[data-button-action="add-to-cart"]', function(e) {
    $(this).addClass('productAdded');
    $('[data-button-action="add-to-cart"]').attr('disabled', true);
  });

  $(document).on('mouseenter mouseleave', '.products:not(.list) .product-miniature', function(e) {

    var $self = $(this),
        $btns = $self.find('.add-to-cart-btn'),
        btnsHeight = $btns.outerHeight(),
        isMobile = $(window).innerWidth() > 767 ? false : true,
        isSlider = $self.parent().hasClass('slick-track'),
        $parent = $self.parent();

        if($self.hasClass('no-hover')) {
          return;
        }


        if(isSlider) {
          var sliderHeight = $self.height();
        }


    if(!isMobile) {
      if(e.type === 'mouseenter') {

        if(isSlider) {
          $self.parent().parent().parent().css({
            'height': $self.parent().parent().parent().height() + 'px',
            'z-index': '11'
          });
          $self.addClass('hightlight');

        } else {
          $self.addClass('hightlight');
          $self.css({
            'height': $self.height() + 'px',
            'margin-bottom': '-' + btnsHeight + 'px'
          });
        }

      } else {

        $self.removeClass('hightlight');
        $self.css({
          'height': '',
          'margin-bottom': ''
        });
        if(isSlider) {
          $self.parent().parent().parent().css({
            'height': '',
            'z-index': ''
          });
        }
      }
    }
  })

  $('.searchToggle').on('click', function() {
    if($('body').hasClass('show-search')) {
      $('body').removeClass('show-search');
    }else {
      $('body').addClass('show-search');
    }
  });

  $('.js-customer-form .js-visible-password').password({
    shortPass: 'Hasło jest za krótkie (minimum 8 znaków)',
    badPass: 'Słabe; spróbuj użyć cyfr i wielkich znaków',
    goodPass: 'Średnie; spróbuj użyć znaków specjalnych',
    strongPass: 'Dobre hasło',
    enterPass: 'Wprowadź hasło',
    showPercent: false,
    username: false,
    usernamePartialMatch: false,
    minimumLength: 8,
    field: '#search_query_top'
  });

  $('.custom-checkbox').find('p + p.details').before('<a class="expand_consent">' + edgard_expandconsent + '</a>');
  $('.data-administrator-text').find('.details').first().before('<a class="expand_consent">' + edgard_expandconsent + '</a>');

  $(document).on('click', '.expand_consent', function (e) {
      e.preventDefault();
      var $a = $(this);
      $a.removeClass('expand_consent').addClass('fold_consent').next('.details').toggle();
      $a.text(edgard_foldconsent);
  });

  $(document).on('click', '.fold_consent', function (e) {
      e.preventDefault();
      var $a = $(this);
      $a.removeClass('fold_consent').addClass('expand_consent').next('.details').toggle();
      $a.text(edgard_expandconsent);
  });

  $(document).on('keyup keydown', '[name="password"]', checkForSamePassword);
  $(document).on('keyup keydown', '[name="password_confirm"]', checkForSamePassword);


  /// USUWANIE ERRORA

  $('.form-group.has-error .form-control').on('keyup', function() {
    $(this).closest('.form-group').removeClass('has-error');
    $(this).parent().find('.help-block').css('display', 'none');
  })

  const showScrollUpArrow = () => {
    const arrow = $('.scroll-up-arrow');
    const wrapperTopPosition = $('#wrapper').offset().top;

    if ($(window).scrollTop() > wrapperTopPosition) {
      arrow.fadeIn(100);
    } else {
      arrow.fadeOut(100);
    }
  };

  $(document).on('click', '.scroll-up-arrow', () => {
    $('html,body').animate({scrollTop: 0}, 'slow');
  });

  showScrollUpArrow();
  $(window).on('scroll', debounce(showScrollUpArrow, 100));
});

function checkForSamePassword() {
  var password = $('.js-customer-form .js-visible-password').val();
  var passwordConfirmation = $('[name="password_confirm"]').val();
  var passwordConfirmationInput = $('[name="password_confirm"]');

  if (password != passwordConfirmation) {
    passwordConfirmationInput.parent().parent().addClass('has-error');
  } else {
    passwordConfirmationInput.parent().parent().removeClass('has-error');
  }
}

function initTooltip() {
  let top = 10;
  if($(window).innerWidth() < 480) {
    top = 3;
  }

  $('[data-toggle="tooltip"]').tooltip({
    position: {
      my: 'center bottom',
      at: 'center top-' + top
    }
  });

}
// end


function handlePushOnCart() {
  const $promoElements = $('.cart-promo-element');

  if($promoElements.length === 0) {
    return;
  }

  $promoElements.wrapAll("<div class='cart-promo-list theme-slider' />");
  $('.cart-promo-list').wrap("<div class='section-bordered cart-promo' />");

  const $promoHeaders = $promoElements.find('.page-heading-bg');
  const $firstPromoHeader = $promoHeaders.first().clone();

  $promoHeaders.hide();

  $('.section-bordered.cart-promo').prepend($firstPromoHeader);

  // if($promoElements.length > 1) {
  //   PushOnCartSliderInit();
  // }
}

function PushOnCartSliderInit($el) {
  $el.slick({
    dots: false,
    infinite: true,
    speed: 600,
    autoplay: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand'
  });

  $('.cart-promo-list').on('afterChange', function (event, slider) {
    let currentSlide = slider.$slides[slider.currentSlide];
    $('.section-bordered.cart-promo > .page-heading-bg > .page-heading').text($(currentSlide).find('.page-heading').text());
  });
}



function fetchSliders() {
  const initSliders = new FetchThenExecute({
    selector: '.theme-slider, .swiper-wrapper',
    files: () => ([
      import('./lib/slick.min.js'),
      import('../css/components/slick.scss'),
    ]),
    fnc: initSlider
  })

  prestashop.on('updatedProduct', () => {
    initSliders.update();
  });
  prestashop.on('updateCart', () => {
    initSliders.update();
    setTimeout(function(){ initSliders.update(); }, 1000);
  });
  $(document).on('quick-view-open', () => {
    initSliders.update();
  });
}
const modalSlickitems = $('.modalImages__slider').data('modal-slider');

function initSlider(el) {
  const $elem = $(el);

  if($elem.hasClass('commentsList')) {
    initCommentsListSlider($elem);
  } else if($elem.hasClass('index-featured:not(.new-products) products') || $elem.hasClass('bestsellers-slider')) {
    initProductsSlider($elem);
  } else if($elem.hasClass('homeBanner__slider')) {
    initHomeBannerSlider($elem);
  } else if($elem.hasClass('new-products') || $elem.hasClass('products-slider')) {
    initNewProductSlider($elem);
  } else if($elem.hasClass('swiper-wrapper')) {
    initProductDescSlider($elem);
  } else if($elem.hasClass('modalImages__slider') && modalSlickitems > 1) {
    initModalSlider($elem);
  } else if($elem.hasClass('js-qv-product-images')) {
    imgThumbSliderInit($elem);
  } else if ($elem.hasClass('cart-promo-list')) {
    if ($('.cart-promo-element').length > 1){
      PushOnCartSliderInit($elem);
    }
  } else if ($elem.hasClass('product-comments-list-slider')) {
    initProductCommentListSlider($elem);
  } else if($elem.hasClass('product-cover-slider')) {
    initProductKapitanSlider($elem);
  } else if($elem.hasClass('blog-mobile-slider')) {
    initBlogMobileSlider($elem);
  }
}

function initBlogMobileSlider($el) {
  $el.slick({
    dots: false,
    infinite: false,
    speed: 600,
    autoplay: false,
    arrows: true,
    slidesToShow: 2,
    slidesToScroll: 2,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function initProductCommentListSlider($el) {
  $el.slick({
    dots: false,
    infinite: false,
    speed: 600,
    autoplay: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 2,
    lazyLoad: 'ondemand',
    adaptiveHeight: true
  });
}

function initProductKapitanSlider($el) {
  $el.slick({
    dots: false,
    infinite: false,
    speed: 700,
    autoplay: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand',
    asNavFor: '.js-qv-product-images'
  });
}

function imgThumbSliderInit($el) {
  const slidesCount = $el.data('slides-count') || 2;
    $el.slick({
      dots: false,
      infinite: false,
      speed: 700,
      autoplay: false,
      arorows: true,
      slidesToShow: slidesCount,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
    });
  }

  const productImagesSelect = () => {
    let imgId = 0;
    $(".select-slick-img").each(function() {
      $(this).attr("data-slick-id", imgId);
      imgId++;
    });
    $(document).on('click', '.select-slick-img', function (e) {
      let dataSlickIndex = e.currentTarget.getAttribute('data-slick-id')
      $('.product-cover-slider').slick('slickGoTo', dataSlickIndex);
    });
    $(document).on('click', '.product-cover .slick-slide', function (e) {
      let slickCoverIndex = e.currentTarget.getAttribute('data-slick-index')
      setTimeout(() => {
        $('.modalImages__slider').slick('slickGoTo', slickCoverIndex);
      }, 500);
    });
  }
  productImagesSelect();

function initModalSlider($el) {
  $el.slick({
    infinite: false,
    arrows: true,
    speed: 600,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    fade: true,
    cssEase: 'linear',
    lazyLoad: 'ondemand'
  });
}
$('#product div[data-target="#product-modal"]').on('click', function() {
  if (modalSlickitems > 1){
    setTimeout(function(){
      initModalSlider($('.modalImages__slider').not('.slick-initialized'));
    }, 500)
  }
});

$('#product-modal').on('hidden.bs.modal', function () {
  if (modalSlickitems > 1){
    $('.modalImages__slider').slick('unslick');
  }
});

function initProductDescSlider($el) {
  $el.slick({
    dots: true,
    infinite: true,
    speed: 700,
    autoplay: false,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand'
  });
}

function initProductsSlider($el) {
  $el.slick({
    dots: false,
    infinite: true,
    speed: 700,
    autoplay: false,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 5,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}
function initCommentsListSlider($el) {
  $el.slick({
    dots: false,
    infinite: false,
    speed: 600,
    autoplay: false,
    arrows: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    lazyLoad: 'ondemand',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 479,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
}

function initHomeBannerSlider($el) {
  $el.slick({
    dots: true,
    infinite: true,
    speed: 600,
    autoplay: false,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    lazyLoad: 'ondemand'
  });
}

function initNewProductSlider($el) {
    const sliderFullWidth = $('.newProducts__item--blockProducts').length > 0 ? false : true;
    let responsive;

    if(!sliderFullWidth) {
      responsive = [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 479,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    } else {
      responsive = [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    $el.slick({
      dots: false,
      infinite: true,
      speed: 600,
      autoplay: false,
      arrows: true,
      slidesToShow: sliderFullWidth ? 5 : 3,
      slidesToScroll: sliderFullWidth ? 5 : 3,
      lazyLoad: 'ondemand',
      responsive: responsive
    });
  }